import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { CurrentUserService } from '@services/current-user.service';
import { canViewRepairTasks } from '@/utils/repair-task-visibility';

export const repairTasksVisibleGuard: CanActivateFn = async () => {
  const currentUserService = inject(CurrentUserService);
  const router = inject(Router);

  const user = await currentUserService.waitForUser();

  if (canViewRepairTasks(user)) {
    return true;
  }

  return router.createUrlTree(['/']);
};
